import { LINK } from '@constants';

/** '공지사항 보러가기'가 여는 포인트 표기방식 변경 안내 공지 상세 경로. */
export const POINT_NOTATION_NOTICE_LINK = `${LINK.NOTICE}/01a0fa24-748f-7607-8b30-ad75cfdaf957`;
